import { render, staticRenderFns } from "./market-edit.vue?vue&type=template&id=6fcee4d0&scoped=true"
import script from "./market-edit.vue?vue&type=script&lang=js"
export * from "./market-edit.vue?vue&type=script&lang=js"
import style0 from "./market-edit.vue?vue&type=style&index=0&id=6fcee4d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcee4d0",
  null
  
)

export default component.exports